<template>

  <section id="dashboard" class="mt-4">

    <div class="container">

        <div class="row">

            <SideNav v-bind:selected="6"/>

            <div class="col-xs-12 col-sm-12 col-md-12 mt-md-0">
                <form id="payment_method" class="mt-2">

                    <input id="old_password" type="password" v-model="oldPassword" name="old_password" placeholder="Old Password"/>
                    <div class="mb-2"></div>
                    <input id="password" type="password" v-model="newPassword" name="password" placeholder="New Password"/>
                    <div class="mb-2"></div>
                    <input id="confirm_password" v-model="newPasswordRepeat" type="password" name="confirm_password" placeholder="Confirm Password"/>

                  <div class="total mt-3">



                    <div class="row mt-3">
                      <div class="col">

                      </div>
                      <div class="col">
                        <button v-on:click="ChangePassword" type="button" class="btn btn-custom mt-3">Save</button> 
                      </div>
                    </div>



                  </div>
                </form>
            </div>
        </div>
    </div>
  </section>


  <Footer/>
</template>

<script>

import Api from '../../scripts/api'

import Footer from '../../components/global/Footer'
import SideNav from '../../components/dashboard/SideNavigator'

export default {
    components: {
        Footer,
        SideNav
    },
    props: {
      account: Object
    },
    data() {
      return {
        oldPassword: '',
        newPassword: '',
        newPasswordRepeat: ''
      }
    },
    methods: {
      ChangePassword: async function() {
        if(this.newPassword != this.newPasswordRepeat) return this.$toast.warning('New password does not match!');
        var result = await Api.changePassword(this.oldPassword, this.newPassword);
        if(result.status == 422) return this.$toast.error('The new password does not meet required parameters, try another password.');
        if(result.status == 401) return this.$toast.error('Unauthorized request, log out and try again.');
        if(result.status == 403) return this.$toast.error('Old password is invalid.');
        if(result.status == 200) {
          return this.$toast.success('Password changed successfully!');
        }
      }
    }
}
</script>